export default __webpack_public_path__ + "static/media/Phillies.adc9b698.png";